import React from 'react'

import PracticeItem from './PracticeItem'
import styles from './PracticeList.css'


function PracticeList ({ practiceList }) {
  return (
    <div className={styles.container}>
      {
        practiceList.map(item =>
          <PracticeItem {...item} key={`pid-${item.pid}-qid-${item.qid}`} />
        )
      }
    </div>
  )
}


export default PracticeList



/** WEBPACK FOOTER **
 ** ./src/components/QuestionList/PracticeList.js
 **/